import { Modal } from '../models/common';

export class ForgotPasswordModal extends Modal {
    public id = 'forgot-password-modal';
    public title = 'Forgot Password';
    public bodyText =
        'A link to reset your current password has been sent to the email address we have on file.';
    public showFooter = true;
    public showOkButton = true;
    public okButtonText = 'Close';
    public showCloseButton = true;
}

export class ForgotPasswordNotLoggedInModal extends ForgotPasswordModal {
    public bodyText =
        'A link to reset your current password has been sent to the email address you entered.';
}
